import React from 'react';
import type {Node} from 'react';
import type {FieldTransformer} from 'sulu-admin-bundle/types';

export default class JsonHeadlineTransformer implements FieldTransformer {
    transform(value: *): Node
    {
        let json = {};

        try
        {
            json = JSON.parse(value);
        }
        catch (error)
        {
           return;
        }

        if('headline' in json)
        {
            return json.headline;
        }
    }
}
